import { theme } from '@/styles/theme';

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  content: {
    backgroundColor: 'white',
  
    p: { xs: 2, sm: 4, md: 6 },
    borderRadius: 2,
   
    width: { xs: '100%', sm: '90%' },
    maxWidth: { xs: '100%', sm: 500 },
    height: { xs: '100vh', sm: 'auto' },
    boxShadow: 3,
  },
  form: {
    width: '100%',
    backgroundColor: 'white',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    mb: 3,
  },
  options: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mt: 1,
    mb: 2,
  },
  link: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.dark,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  buttonContainer: {
    mt: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    position: 'relative',
  },
};
